import Debug   from './theme/debug.js';
import Helpers from './theme/helpers.js';

import TestComponent from './theme/components/test-component.js';
import MobileNavigation from './theme/components/mobile-navigation.js';
import KeysNavigation from './theme/components/keys-navigation.js';

window.theme = {
    globals: {
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        let theme = this;

        theme.debug = new Debug;
        theme.helpers = new Helpers;

        theme.testComponent = new TestComponent;
        theme.mobileNavigation = new MobileNavigation;
        theme.keysNavigation = new KeysNavigation;
    }
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );
